export class ImageRejectMultipleModel {
    public imageIdList: Array<number>;

    constructor() {
        this.imageIdList = new Array<number>();
    }

}
